import { CheckEmailDto, UserCheckEmailDto } from '@/modules/user/core/schemas/check-email'
import { CreateCommentDto } from '@/modules/user/core/schemas/create-comment.schema'
import { CreateUserApplicationDto } from '@/modules/user/core/schemas/create-user-application.schema'
import { UpdatePersonalDataValues } from '@/modules/user/core/schemas/update-personal-data.schema'
import { UploadResumeDto } from '@/modules/user/core/schemas/upload-resume.schema'
import { IUserRepository } from '@/modules/user/core/user.repository.interface'
import {
  UserSearchResponse,
  User,
  UserPersonalData,
  PaginatedUserCommentResponse,
  UserApplicationsHistoryResponse,
  UserInterviewResponse,
  UserEmailsResponse,
} from '@/modules/user/core/user.types'
import { IdResponseDto } from '@/shared/domain/entities/common.entity.ts'
import { PaginationDto } from '@/shared/domain/entities/pagination.entity'
import { UpdateJobPreferencesData } from '@/shared/domain/schemas/update-job-preferences.schema'
import { JobPreferences } from '@/types/application/applicant-info'

import { CreateTagsSchema } from './schemas/create-tags'

export class UserService {
  constructor(private userRepository: IUserRepository) {}

  async search(query: string): Promise<UserSearchResponse> {
    return this.userRepository.search(query)
  }

  async get(id: string): Promise<User> {
    return this.userRepository.get(id)
  }

  async getPersonalData(id: string): Promise<UserPersonalData> {
    return this.userRepository.getPersonalData(id)
  }

  async updatePersonalData(id: string, data: UpdatePersonalDataValues): Promise<IdResponseDto> {
    return this.userRepository.updatePersonalData(id, data)
  }

  async checkEmail(data: CheckEmailDto): Promise<UserCheckEmailDto> {
    return this.userRepository.checkEmail(data)
  }

  async createApplication(data: CreateUserApplicationDto): Promise<IdResponseDto> {
    return this.userRepository.createApplication(data)
  }

  async uploadResume(data: FormData): Promise<UploadResumeDto> {
    return this.userRepository.uploadResume(data)
  }

  async getUserComments(userId: string, pagination: PaginationDto): Promise<PaginatedUserCommentResponse> {
    return this.userRepository.getUserComments(userId, pagination)
  }

  async createUserComment(userId: string, data: CreateCommentDto): Promise<IdResponseDto> {
    return this.userRepository.createUserComment(userId, data)
  }

  async updateJobPreferences(id: string, data: Partial<UpdateJobPreferencesData>): Promise<JobPreferences> {
    return this.userRepository.updateJobPreferences(id, data)
  }

  async createTag(userId: string, data: CreateTagsSchema): Promise<IdResponseDto> {
    return this.userRepository.createTag(userId, data)
  }

  async getApplicationsHistory(userId: string): Promise<UserApplicationsHistoryResponse[]> {
    return this.userRepository.getApplicationsHistory(userId)
  }

  async getInterviews(userId: string): Promise<UserInterviewResponse[]> {
    return this.userRepository.getInterviews(userId)
  }

  async getEmails(userId: string): Promise<UserEmailsResponse[]> {
    return this.userRepository.getEmails(userId)
  }
}
